export const ItemTypes = {
  IMAGE: 'image'
}

